"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoricalSelection = exports.featureSelection = exports.featureHighlights = exports.secondSingleHighlight = exports.singleHighlight = exports.multipleHighlights = exports.categorical = exports.ngram = void 0;
exports.ngram = {
    feature: {
        uuid: "03927b05-6784-4b7c-ab39-4c9823769648",
        type: "ngram",
        ngram: "perforation",
        slop: 1,
        in_order: true,
        display: true,
        field: "raw_body",
        spans: [
            {
                start: 91,
                end: 192,
                uuid: "83915a85-c519-4d41-b32e-646e75466703",
                document_id: 234325,
                content: "perforation",
                level: "ngram"
            },
            {
                start: 91,
                end: 192,
                uuid: "83915a85-c519-4d41-b32e-646e75466703",
                document_id: 234325,
                content: "perforation",
                level: "sentence"
            }
        ]
    },
    type: "Ngram",
    score: 1.8524357683146013
};
exports.categorical = {
    feature: {
        uuid: "bla blah blah",
        type: "ngram",
        ngram: "fever, cough",
        field: "reason_for_visit",
        slop: 1,
        in_order: true
    },
    type: "Categorical",
    score: 1.8524357683146013
};
exports.multipleHighlights = {
    code: {
        uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cg",
        confidence: 0.9900000000000001,
        diagnosis_code: "Q66.6",
        evidence: [
            {
                feature: {
                    uuid: "904c9836-3024-4a9f-8f71-acbf5a0583ec",
                    type: "ngram",
                    ngram: "pain",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 3,
                            end: 23,
                            uuid: "d552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            content: "pain",
                            level: "ngram"
                        },
                        {
                            start: 3,
                            end: 23,
                            uuid: "d552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            content: "pain",
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            },
            {
                feature: {
                    uuid: "dd23ee4d-12c9-45bf-bf3a-4b8e72ccb9b3",
                    type: "ngram",
                    ngram: "perforation",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 91,
                            end: 192,
                            content: "perforation",
                            uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 91,
                            end: 192,
                            content: "perforation",
                            uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                            document_id: 234325,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            }
        ]
    },
    artifactId: "10",
    codeType: "icd",
    display: true,
    evidence: [
        {
            feature: {
                uuid: "83fefc4c-8701-49f9-8e2d-116e01d3ae42",
                type: "ngram",
                ngram: "pain",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "93019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "93019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "dd23ee4d-12c9-45bf-bf3a-4b8e72ccb9b3",
                type: "ngram",
                ngram: "perforation",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 91,
                        end: 192,
                        content: "perforation",
                        uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 91,
                        end: 192,
                        content: "perforation",
                        uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                        document_id: 234325,
                        level: "sentence"
                    },
                    {
                        start: 191,
                        end: 392,
                        content: "perforation",
                        uuid: "138edb47-10cf-475b-98ee-601458aca1bb",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 191,
                        end: 392,
                        content: "perforation",
                        uuid: "138edb47-10cf-475b-98ee-601458aca1bb",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
};
exports.singleHighlight = {
    code: {
        uuid: "123a68d1-adca-4a66-8a3f-3fb7803577cg",
        confidence: 0.9900000000000001,
        diagnosis_code: "Q66.6",
        evidence: [
            {
                feature: {
                    uuid: "104c9836-3024-4a9f-8f71-acbf5a0583ec",
                    type: "ngram",
                    ngram: "pain",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "1552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "1552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "1552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234324,
                            level: "ngram"
                        },
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "1552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234324,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            }
        ]
    },
    artifactId: "11",
    codeType: "icd",
    display: true,
    evidence: [
        {
            feature: {
                uuid: "13fefc4c-8701-49f9-8e2d-116e01d3ae42",
                type: "ngram",
                ngram: "pain",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "13019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "13019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
};
exports.secondSingleHighlight = {
    code: {
        uuid: "223a68d1-adca-4a66-8a3f-3fb7803577cg",
        confidence: 0.9900000000000001,
        diagnosis_code: "V66.6",
        evidence: [
            {
                feature: {
                    uuid: "204c9836-3024-4a9f-8f71-acbf5a0583ec",
                    type: "ngram",
                    ngram: "pain",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "2552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "2552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            }
        ]
    },
    artifactId: "12",
    codeType: "icd",
    display: true,
    evidence: [
        {
            feature: {
                uuid: "23fefc4c-8701-49f9-8e2d-116e01d3ae42",
                type: "ngram",
                ngram: "pain",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "23019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "23019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        }
    ]
};
exports.featureHighlights = {
    code: {
        uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cg",
        confidence: 0.9900000000000001,
        diagnosis_code: "Q66.6",
        evidence: [
            {
                feature: {
                    uuid: "53c49571-6222-4311-ac9e-fe7ad39afb19",
                    type: "prior"
                },
                type: "Prior",
                score: -0.00001054492930037871
            },
            {
                feature: {
                    uuid: "dd23ee4d-12c9-45bf-bf3a-4b8e72ccb9b3",
                    type: "ngram",
                    ngram: "perforation",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 91,
                            end: 192,
                            content: "perforation",
                            uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 91,
                            end: 192,
                            content: "perforation",
                            uuid: "5dff466d-c29d-44ff-87fe-18a2b8101d48",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 191,
                            end: 392,
                            content: "perforation",
                            uuid: "138edb47-10cf-475b-98ee-601458aca1bb",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 191,
                            end: 392,
                            content: "perforation",
                            uuid: "138edb47-10cf-475b-98ee-601458aca1bb",
                            document_id: 234325,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            },
            {
                feature: {
                    uuid: "904c9836-3024-4a9f-8f71-acbf5a0583ec",
                    type: "ngram",
                    ngram: "pain",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "d552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 3,
                            end: 23,
                            content: "pain",
                            uuid: "d552c6ce-09bf-4f76-a68b-c1c81f270c8f",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 95,
                            end: 193,
                            content: "pain",
                            uuid: "30a74260-4526-4369-803d-ba838aa732f9",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 95,
                            end: 193,
                            content: "pain",
                            uuid: "30a74260-4526-4369-803d-ba838aa732f9",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 33,
                            end: 69,
                            content: "pain",
                            uuid: "d2635119-5a83-4a3d-951c-6b4e672b9815",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 33,
                            end: 69,
                            content: "pain",
                            uuid: "d2635119-5a83-4a3d-951c-6b4e672b9815",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 80,
                            end: 163,
                            content: "pain",
                            uuid: "1f21dd5f-7b4e-4ce3-be98-38322f72629b",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 80,
                            end: 163,
                            content: "pain",
                            uuid: "1f21dd5f-7b4e-4ce3-be98-38322f72629b",
                            document_id: 234325,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            },
            {
                feature: {
                    uuid: "2bb57f5d-95cf-483f-be5a-77ea9409ad15",
                    type: "ngram",
                    ngram: "distention",
                    slop: 1,
                    in_order: true,
                    display: true,
                    field: "raw_body",
                    spans: [
                        {
                            start: 91,
                            end: 101,
                            content: "distention",
                            uuid: "e6a9ecdd-da4e-4136-8da9-c4113b1f1332",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 91,
                            end: 101,
                            content: "distention",
                            uuid: "e6a9ecdd-da4e-4136-8da9-c4113b1f1332",
                            document_id: 234325,
                            level: "sentence"
                        },
                        {
                            start: 2459,
                            end: 2469,
                            content: "distention",
                            uuid: "f5004060-53f5-4837-adba-49c5d018e7e8",
                            document_id: 234325,
                            level: "ngram"
                        },
                        {
                            start: 2459,
                            end: 2469,
                            content: "distention",
                            uuid: "f5004060-53f5-4837-adba-49c5d018e7e8",
                            document_id: 234325,
                            level: "sentence"
                        }
                    ]
                },
                type: "Ngram",
                score: 1.8524357683146013
            },
            {
                feature: {
                    uuid: "3666d79f-a0ba-49e0-9f8c-889a171d5954",
                    type: "ngram",
                    ngram: "fever, cough",
                    field: "reason_for_visit",
                    slop: 1,
                    in_order: true
                },
                type: "Ngram",
                score: 1.8510916053185522
            },
            {
                feature: {
                    uuid: "fee35cab-0fcf-4dc2-9fed-22cab2a38222",
                    type: "ngram",
                    ngram: "CT ABD/PELVIS",
                    field: "body_region",
                    slop: 1,
                    in_order: true
                },
                type: "Ngram",
                score: -1.8510916053185522
            }
        ]
    },
    artifactId: "10",
    codeType: "icd",
    display: true,
    evidence: [
        {
            feature: {
                uuid: "cda8931a-4275-4c28-8f16-747c4eee198b",
                type: "prior"
            },
            type: "Prior",
            score: -0.00001054492930037871
        },
        {
            feature: {
                uuid: "cfa37b1f-aa8f-468e-a76d-36448003661c",
                type: "ngram",
                ngram: "perforation",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 91,
                        end: 192,
                        content: "perforation",
                        uuid: "4c9a854e-422f-4c3e-87c7-9b68a1e54c23",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 91,
                        end: 192,
                        content: "perforation",
                        uuid: "4c9a854e-422f-4c3e-87c7-9b68a1e54c23",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "6a4bbf27-4ace-4867-8e22-7f933dacdfba",
                type: "ngram",
                ngram: "fever, cough",
                field: "reason_for_visit",
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: 1.8510916053185522
        },
        {
            feature: {
                uuid: "83fefc4c-8701-49f9-8e2d-116e01d3ae42",
                type: "ngram",
                ngram: "pain",
                slop: 1,
                in_order: true,
                display: true,
                field: "raw_body",
                spans: [
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "93019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 3,
                        end: 23,
                        content: "pain",
                        uuid: "93019492-b36b-4db5-a047-750f69ae9978",
                        document_id: 234325,
                        level: "sentence"
                    },
                    {
                        start: 95,
                        end: 193,
                        content: "pain",
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 95,
                        end: 193,
                        content: "pain",
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
                        document_id: 234325,
                        level: "sentence"
                    },
                    {
                        start: 33,
                        end: 69,
                        content: "pain",
                        uuid: "adc10ff5-0365-41a3-b662-9a7a0b865961",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 33,
                        end: 69,
                        content: "pain",
                        uuid: "adc10ff5-0365-41a3-b662-9a7a0b865961",
                        document_id: 234325,
                        level: "sentence"
                    },
                    {
                        start: 80,
                        end: 163,
                        content: "pain",
                        uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cc",
                        document_id: 234325,
                        level: "ngram"
                    },
                    {
                        start: 80,
                        end: 163,
                        content: "pain",
                        uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cc",
                        document_id: 234325,
                        level: "sentence"
                    }
                ]
            },
            type: "Ngram",
            score: 1.8524357683146013
        },
        {
            feature: {
                uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cd",
                type: "ngram",
                ngram: "CT ABD/PELVIS",
                field: "body_region",
                slop: 1,
                in_order: true
            },
            type: "Ngram",
            score: -1.8510916053185522
        }
    ]
};
exports.featureSelection = __assign(__assign({}, exports.featureHighlights), { evidence: {
        feature: {
            uuid: "523a68d1-adca-4a66-8a3f-3fb7803577ce",
            type: "ngram",
            ngram: "perforation",
            slop: 1,
            in_order: true,
            display: true,
            field: "raw_body",
            spans: [
                {
                    start: 91,
                    end: 192,
                    content: "perforation",
                    uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cf",
                    document_id: 234325,
                    level: "ngram"
                },
                {
                    start: 91,
                    end: 192,
                    content: "perforation",
                    uuid: "523a68d1-adca-4a66-8a3f-3fb7803577cf",
                    document_id: 234325,
                    level: "sentence"
                }
            ]
        },
        type: "Ngram",
        score: 1.8524357683146013
    } });
//@ts-ignore
delete exports.featureSelection["features"];
exports.categoricalSelection = {
    code: exports.featureSelection.code,
    evidence: exports.categorical,
    artifactId: 2,
    codeType: "ICD",
    display: true
};
//# sourceMappingURL=stock-predictions.js.map